import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode } from "vue";
import _imports_0 from '@/assets/images/back.png';
import _imports_1 from '@/assets/images/collapse_a.svg';
import _imports_2 from '@/assets/images/down.png';
import _imports_3 from '@/assets/images/clear.png';
const _hoisted_1 = { class: "header flexRow-alc flex-jcsb" };
const _hoisted_2 = { class: "flexRow-alc" };
const _hoisted_3 = {
    key: 2,
    style: { "margin-left": "10px" }
};
const _hoisted_4 = { class: "flexRow-alc" };
const _hoisted_5 = { class: "flexRow-alc" };
const _hoisted_6 = {
    key: 1,
    class: "flexRow-alc"
};
const _hoisted_7 = { class: "user flexRow-alc clickable" };
const _hoisted_8 = ["src"];
import { reactive, computed, ref } from 'vue';
import { useStore } from 'vuex';
import { useRoute, useRouter } from 'vue-router';
import request from '@/api/request';
import feedback from '@/utils/feedback';
import emitter from '@/utils/eventBus';
import { ElMessage } from 'element-plus';
import ycPopoverList from '@/components/yc-popover-list/yc-popover-list.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'header',
    setup(__props) {
        const router = useRouter();
        const route = useRoute();
        const store = useStore();
        const ycPopoverListRef = ref();
        // 用户信息
        const userInfo = computed(() => store.state.userInfo);
        // 返回上一页
        const backList = ref([
            '/setting', '/intelligence_fileConversion', '/intelligence_chat', '/meeting/detail', '/stencilTheme',
            '/outline', '/simultaneousTranslation/generate', '/meeting/room'
        ]);
        const goBack = async () => {
            var _a, _b, _c, _d, _e;
            if (!((_b = (_a = window.history) === null || _a === void 0 ? void 0 : _a.state) === null || _b === void 0 ? void 0 : _b.back)) {
                return router.push('/');
            }
            // 点击返回大纲页时，判断是否正在ppt大纲生成中
            // 如果是，则提示用户是否确认返回大纲页
            if (route.name === '/outline') {
                if (!store.state.chatStatus) {
                    try {
                        await feedback.confirm('PPT大纲已生成，切换页面将不保存，确认切换？');
                    }
                    catch (error) {
                        return;
                    }
                }
                return router.replace({ name: '/pptMake' });
            }
            if (route.name === '/meeting/room') {
                return router.replace({ name: '/meeting/selectLang' });
            }
            // 判断智能体返回
            if (route.name === '/intelligence_chat' && ((_e = (_d = (_c = window.history) === null || _c === void 0 ? void 0 : _c.state) === null || _d === void 0 ? void 0 : _d.back) === null || _e === void 0 ? void 0 : _e.indexOf('/intelligence_chat')) !== -1) {
                if (store.state.intelligenceStatus) {
                    try {
                        await feedback.confirm('您正在智能体对话中，页面会中断回答。');
                        backIntelligence();
                    }
                    catch (error) { }
                    return;
                }
                backIntelligence();
                return;
            }
            // 判断是否是同时翻译生成页
            if (route.name === '/simultaneousTranslation/generate') {
                return router.replace({ name: '/simultaneousTranslation/introduce' });
            }
            router.go(-1);
        };
        // 智能体返回
        const backIntelligence = () => {
            var _a, _b;
            // 解析上一页的路由参数
            const backRoute = (_b = (_a = window.history) === null || _a === void 0 ? void 0 : _a.state) === null || _b === void 0 ? void 0 : _b.back;
            const backRouteParams = new URLSearchParams(backRoute.split('?')[1]);
            const backRouteParamsObj = Object.fromEntries(backRouteParams);
            router.go(-1);
            emitter.emit('goIntelligence', {
                id: backRouteParamsObj === null || backRouteParamsObj === void 0 ? void 0 : backRouteParamsObj.historyId,
                modelId: backRouteParamsObj === null || backRouteParamsObj === void 0 ? void 0 : backRouteParamsObj.id,
                modelName: backRouteParamsObj === null || backRouteParamsObj === void 0 ? void 0 : backRouteParamsObj.name,
            });
        };
        // 标题
        const showTitle = computed(() => { var _a; return ((_a = route.query) === null || _a === void 0 ? void 0 : _a.showTitle) || 0; });
        // 用户操作
        const handleUserChange = async (item, index) => {
            var _a, _b, _c, _d;
            if (item.key == 'outlogin') {
                (_b = (_a = ycPopoverListRef.value) === null || _a === void 0 ? void 0 : _a.getRef()) === null || _b === void 0 ? void 0 : _b.hide();
                // 需要提示方可跳转
                let tipsRoute = ['/meeting/room', '/simultaneousTranslation/generate']; // 需提示路由
                if (tipsRoute.includes(route.name)) {
                    try {
                        const tipsRes = await feedback.confirm('您正在录制中，确定要切换页面吗？');
                        if (tipsRes == 'confirm') {
                            // 退出登录
                            localStorage.removeItem('token');
                            store.commit('setToken', '');
                            store.state.userInfo = {};
                            router.replace('/');
                        }
                    }
                    catch (error) {
                        return;
                    }
                    return;
                }
                try {
                    await feedback.confirm('确定要退出登录吗？');
                    // 退出登录
                    localStorage.removeItem('token');
                    store.commit('setToken', '');
                    store.state.userInfo = {};
                    router.replace('/');
                }
                catch (error) {
                }
            }
            if (item.key == 'setting') {
                router.push('/setting');
            }
            (_d = (_c = ycPopoverListRef.value) === null || _c === void 0 ? void 0 : _c.getRef()) === null || _d === void 0 ? void 0 : _d.hide();
        };
        // 侧边栏操作
        const isCollapse = computed(() => store.state.isCollapse);
        const handleCollapse = () => {
            store.commit('handleCollapse', !isCollapse.value);
        };
        // 更多操作
        const ycPopoverMoreRef = ref();
        const moreLists = reactive([{ name: '复制文本', key: 'copy' }, { name: '生成TXT', key: 'txt' }, { name: '生成DOC', key: 'doc' }]);
        const handleMore = (item) => {
            var _a, _b;
            emitter.emit('simultaneousTranslationExport', item.key);
            (_b = (_a = ycPopoverMoreRef.value) === null || _a === void 0 ? void 0 : _a.getRef()) === null || _b === void 0 ? void 0 : _b.hide();
        };
        const clearRoute = ['/deepseek', '/nineHeavens', '/tabulation', '/toPicture'];
        // 需展示清除按钮
        const showClear = computed(() => {
            var _a;
            return store.state.histroyOther.status || (clearRoute.includes(String(route.name)) && ((_a = route.query) === null || _a === void 0 ? void 0 : _a.id)) || route.query && route.query.chatid || false;
        });
        // 开启语音通话
        const openVoicecall = async () => {
            if (route.path === '/preview') {
                try {
                    await feedback.confirm('确定要开启语音通话吗？');
                }
                catch (error) {
                    return;
                }
            }
            if (route.path == '/voicecall') {
                // 通话页面
                emitter.emit('openVoicecall');
            }
            else {
                // 非通话页面
                router.push('/voicecall');
            }
        };
        // 登录
        const goLogin = () => {
            store.commit('setLoginStatus', { status: true });
        };
        // 清空历史
        const handleClear = () => {
            feedback
                .confirm('确定删除此对话？')
                .then(res => {
                var _a, _b;
                if (res === 'confirm') {
                    if (((_a = route === null || route === void 0 ? void 0 : route.query) === null || _a === void 0 ? void 0 : _a.viewType) == 'drawing' || (route === null || route === void 0 ? void 0 : route.name) === '/toPicture') {
                        deleteDrawChat();
                    }
                    else if ((route === null || route === void 0 ? void 0 : route.name) === '/tabulation' && ((_b = route === null || route === void 0 ? void 0 : route.query) === null || _b === void 0 ? void 0 : _b.id)) {
                        emitter.emit('deleteTabulation');
                    }
                    else {
                        deleteChat();
                    }
                }
            })
                .catch(() => { });
        };
        // 删除对话
        const deleteChat = () => {
            var _a, _b;
            request
                .delete(`/app-api/lt/ai/chat/conversation/delete-my?id=${(route === null || route === void 0 ? void 0 : route.query.chatid) || ((_a = route === null || route === void 0 ? void 0 : route.query) === null || _a === void 0 ? void 0 : _a.id) || ((_b = route === null || route === void 0 ? void 0 : route.query) === null || _b === void 0 ? void 0 : _b.historyId) || ''}`, {})
                .then((delRes) => {
                if ((delRes === null || delRes === void 0 ? void 0 : delRes.code) == 0) {
                    store.commit('setHistroyOther', { status: false });
                    store.commit('setHistroyList');
                    router.push('/');
                }
            })
                .catch(() => { });
        };
        // 删除绘画对话
        const deleteDrawChat = () => {
            var _a, _b;
            request
                .post(`/app-api/lt/ai/image/deleteAllSession`, {
                id: (route === null || route === void 0 ? void 0 : route.query.chatid) || ((_a = route === null || route === void 0 ? void 0 : route.query) === null || _a === void 0 ? void 0 : _a.id) || ((_b = route === null || route === void 0 ? void 0 : route.query) === null || _b === void 0 ? void 0 : _b.historyId) || ''
            })
                .then((delRes) => {
                if ((delRes === null || delRes === void 0 ? void 0 : delRes.code) == 0) {
                    store.commit('setHistroyOther', { status: false });
                    router.push('/');
                }
                else {
                    ElMessage.warning(delRes === null || delRes === void 0 ? void 0 : delRes.msg);
                }
            })
                .catch(() => { });
        };
        return (_ctx, _cache) => {
            var _a;
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    (backList.value.includes(String(_unref(route).name)))
                        ? (_openBlock(), _createElementBlock("p", {
                            key: 0,
                            class: "clickable flexRow-alc",
                            onClick: goBack
                        }, _cache[0] || (_cache[0] = [
                            _createElementVNode("img", {
                                src: _imports_0,
                                alt: "",
                                style: { "width": "24px" }
                            }, null, -1)
                        ])))
                        : _createCommentVNode("", true),
                    (isCollapse.value)
                        ? (_openBlock(), _createElementBlock("p", {
                            key: 1,
                            class: "clickable flexRow-alc",
                            onClick: handleCollapse
                        }, _cache[1] || (_cache[1] = [
                            _createElementVNode("img", { src: _imports_1 }, null, -1)
                        ])))
                        : _createCommentVNode("", true),
                    (showTitle.value == '1')
                        ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString((_a = _unref(route).query) === null || _a === void 0 ? void 0 : _a.title), 1))
                        : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_4, [
                    (_unref(route).name === '/simultaneousTranslation/generate')
                        ? (_openBlock(), _createBlock(ycPopoverList, {
                            key: 0,
                            ref_key: "ycPopoverMoreRef",
                            ref: ycPopoverMoreRef,
                            lists: moreLists,
                            onChange: handleMore,
                            showBr: false
                        }, {
                            content: _withCtx(() => _cache[2] || (_cache[2] = [
                                _createElementVNode("p", { class: "clickable flexRow-alc" }, [
                                    _createElementVNode("img", {
                                        src: _imports_2,
                                        style: { "width": "24px", "margin-right": "24px" }
                                    })
                                ], -1)
                            ])),
                            _: 1
                        }, 8, ["lists"]))
                        : _createCommentVNode("", true),
                    (showClear.value)
                        ? (_openBlock(), _createElementBlock("p", {
                            key: 1,
                            class: "clickable flexRow-alc",
                            onClick: handleClear
                        }, _cache[3] || (_cache[3] = [
                            _createElementVNode("img", {
                                src: _imports_3,
                                style: { "width": "24px", "margin-right": "20px" }
                            }, null, -1)
                        ])))
                        : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_5, [
                        (!userInfo.value.id)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                class: "login clickable",
                                onClick: goLogin
                            }, "登录"))
                            : (_openBlock(), _createElementBlock("div", _hoisted_6, [
                                _createVNode(ycPopoverList, {
                                    ref_key: "ycPopoverListRef",
                                    ref: ycPopoverListRef,
                                    lists: [{ icon: 'Setting', name: '设置', key: 'setting' }, { icon: 'SwitchButton', name: '退出登录', key: 'outlogin' }],
                                    onChange: handleUserChange
                                }, {
                                    content: _withCtx(() => {
                                        var _a;
                                        return [
                                            _createElementVNode("div", _hoisted_7, [
                                                _createElementVNode("img", {
                                                    src: ((_a = userInfo.value) === null || _a === void 0 ? void 0 : _a.avatar) || 'https://ai-web-1320245968.cos.ap-guangzhou.myqcloud.com/comm%2Favatar_g.png'
                                                }, null, 8, _hoisted_8)
                                            ])
                                        ];
                                    }),
                                    _: 1
                                }, 512)
                            ]))
                    ])
                ])
            ]));
        };
    }
});
